// extracted by mini-css-extract-plugin
export default {"rightButton":"styles_rightButton__1PR-g","btn_back":"styles_btn_back__tfr-T","rightButton_lection":"styles_rightButton_lection__NGT+I"};